import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TrendGraphSettingsService {
    public get updateInterval(): number {
        return 1000;
    }
}
